<template>
  <a-modal
    :title="title"
    :width="1080"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    @ok="this.ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form">
        <a-row>
          <a-col :span="24">
            <a-divider orientation="left">
              关联信息
            </a-divider>
          </a-col>
          <a-col :span="12" v-if="true">
            <a-form-item label="采销全流程" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'project_id',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="请输入名称"
                :default-active-first-option="false"
                @search="this.projectSearch"
                @change="handleProjectChange"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in projectList" :key="d.id">
                  {{ d.name }}（{{ d.number }}）
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="sellContractLabel" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'sell_contract_id',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="请选择"
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-spin v-if="sellContractFetching" slot="notFoundContent" size="small" />
                <a-select-option :key="key" :value="val.id" v-for="(val, key) in sellContractList">{{ val.name }}（{{ val.number }}）</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="project_id > 0 && model['type'] !== 3">
            <a-form-item :label="totalCountLabel" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <span style="padding-left: 10px" v-if="model['type'] === 1">{{ total_count }}</span>
              <span style="padding-left: 10px" v-if="model['type'] === 2">{{ remaining_total_count }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              {{ model['type'] === 1 ? '入库信息' : '出库信息' }}
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="编号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" :layout="formLayout">
            <a-form-item label="仓库" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="warehouseFetching ? undefined : null"
                show-search
                allow-clear
                v-decorator="[
                  'warehouse_id',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="请输入仓库"
                :default-active-first-option="false"
                @search="this.warehouseSearch"
                @change="handleWarehouseChange"
              >
                <a-spin v-if="warehouseFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in warehouseList" :key="d.id" :tt="d.name">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model['type'] === 2">
            <a-form-item label="货转模式" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                show-search
                allow-clear
                v-decorator="[
                  'goods_transfer_mode',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="请选择"
                :default-active-first-option="false"
              >
                <a-select-option v-for="(item, index) in freightTransferModeList" :key="index" :tt="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model['type'] === 3">
            <a-form-item label="耗损类型" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                show-search
                allow-clear
                v-decorator="[
                  'loss_type',
                  {
                    rules: [
                      { required: true, message: '' },
                    ],
                  },
                ]"
                placeholder="请选择"
                :default-active-first-option="false"
              >
                <a-select-option v-for="(item, index) in depletionTypeList" :key="index" :tt="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="提货单毛量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['gross_weight', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="提货单毛量"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="提货单净量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['net_weight', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="提货单净量"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="过磅量" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['weighing_capacity', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="过磅量"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="model['type'] === 1 ? '实收数量' : '实发数量'" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="4" style="width: 50%" v-decorator="['real_weight', {rules: [{required: false, message: '必填项，请填写信息'}]}]" :placeholder="model['type'] === 1 ? '实收数量' : '实发数量'"/>
              <a-tooltip :title="(model['type'] === 1 ? '实收数量' : '实发数量') + '：外贸业务为报关单数量；内贸业务为进项发票取得数量。此数量推送到金蝶系统中使用。'">
                <a-icon type="info-circle" theme="filled" style="padding-left: 8px"/>
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model['type'] !== 3">
            <a-form-item label="单位" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'unit',
                  {
                    rules: [
                      { required: false, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.unit">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model['type'] !== 3">
            <a-form-item label="单价" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['unit_price', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="单价"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model['type'] !== 3">
            <a-form-item label="货币" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'currency',
                  {
                    rules: [
                      { required: false, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.currency">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model['type'] !== 3">
            <a-form-item label="预估人民币单价" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['unit_price_cny', {rules: [{required: false, message: '必填项，请填写信息'}]}]" placeholder="预估人民币单价"/>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="false">
            <a-form-item label="备注" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-textarea :auto-size="{ minRows:2, maxRows:4 }" v-decorator="['remark', {rules: [{required: false, message: '必填项，请填写信息'}]}]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="inOutDateLabel" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['in_out_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                :placeholder="inOutDateLabel"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="model['type'] === 1">
            <a-form-item label="报关日期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-date-picker
                v-decorator="['declaration_date', {rules: [{required: false, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                :placeholder="inOutDateLabel"
                value-format="yyyy-MM-DD"
              />
              <a-tooltip title="报关日期：外贸业务为报关单申报日期；内贸业务为进项发票取得日期。此日期推送到金蝶系统中使用。">
                <a-icon type="info-circle" theme="filled" style="padding-left: 8px"/>
              </a-tooltip>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              审批信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开启审批" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-switch v-decorator="['is_approval_needed', { initialValue: false, valuePropName: 'checked' }]"/>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="model['type'] !== 3">
            <a-divider orientation="left">
              附件信息
            </a-divider>
          </a-col>
          <a-col :span="24" v-if="model['type'] !== 3">
            <a-form-item label="附件" :label-col="buttonItemLayout.labelCol" :wrapper-col="buttonItemLayout.wrapperCol">
              <a-button icon="plus" @click="handleAddAttachment">新建</a-button>
              <a-table
                bordered
                :data-source="otherData.attachment"
                :columns="attachmentColumns"
                v-if="this.otherData.attachment.length > 0"
                :pagination="false"
                key="key">
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    v-if="otherData.attachment.length"
                    title="确定删除?"
                    @confirm="() => onAttachmentDelete(record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <attachment-create-form
        ref="attachmentCreateForm"
        @cancel="handleAddCancel"
        @ok="handleOk"
        :record="mdl"
        :visible="visibleFrom"
        v-if="visibleFrom"
        :loading="confirmLoadingFrom"
        :model="mdl" />
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { project_list } from '@/api/trade_project'
import { warehouse_list } from '@/api/trade_warehouse'
import debounce from 'lodash/debounce'
import AttachmentCreateForm from '../attachment/modules/CreateForm'
import { inventory_total } from '@/api/trade_inventory'
import { sell_contract_list } from '@/api/trade_sell_contract'

// 表单字段
const fields = ['id', 'number', 'contact', 'phone', 'mail']
export default {
  components: {
    AttachmentCreateForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    this.warehouseSearch = debounce(this.handleWarehouseSearch, 800)
    return {
      formLayout: 'horizontal',
      color: '#3f3f3f',
      form: this.$form.createForm(this),
      total_count: 0,
      remaining_total_count: 0,
      projectList: [],
      warehouseList: [],
      sellContractList: [],
      depletionTypeList: this.$Dictionaries.trade_inventory_loss_type,
      freightTransferModeList: this.$Dictionaries.trade_inventory_goods_transfer_mode,
      unit: this.$Dictionaries.unit,
      currency: this.$Dictionaries.currency,
      visibleFrom: false,
      confirmLoadingFrom: false,
      projectFetching: false,
      warehouseFetching: false,
      sellContractFetching: false,
      project_id: undefined,
      mdl: {},
      otherData: {
        attachment: []
      },
      attachmentColumns: [
        {
          title: '名称',
          dataIndex: 'name'
        },
        {
          title: '附件',
          dataIndex: 'url'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    console.log('custom modal created', this.model)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    this.model && this.form.setFieldsValue(pick(this.model, fields))
  },
  computed: {
    title () {
      if (this.model['type'] === 1) {
        return '新建入库'
      } else if (this.model['type'] === 2) {
        return '新建出库'
      } else {
        return '新建平账'
      }
    },
    inOutDateLabel () {
      if (this.model['type'] === 1) {
        return '入库时间'
      } else if (this.model['type'] === 2) {
        return '出库时间'
      } else {
        return '出库时间'
      }
    },
    sellContractLabel () {
      if (this.model['type'] === 1) {
        return '采购合同'
      } else if (this.model['type'] === 2) {
        return '销售合同'
      } else {
        return '销售合同'
      }
    },
    totalCountLabel () {
      if (this.model['type'] === 1) {
        return '总入库量'
      } else if (this.model['type'] === 2) {
        return '剩余库量'
      } else {
        return ''
      }
    },
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 6 },
          wrapperCol: { span: 18 }
        } : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 3 },
          wrapperCol: { span: 21 }
        } : {}
    }
  },
  methods: {
    handleProjectSearch (value) {
      this.projectFetching = true
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleProjectChange (value) {
      console.log(value)
      this.project_id = value
      if (value !== undefined) {
        this.inventoryTotal()
        this.loadSellContractInfo()
      }
    },
    handleWarehouseSearch (value) {
      this.warehouseFetching = true
      this.warehouseList = []
      warehouse_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.warehouseList = result
      }).finally(() => {
        this.warehouseFetching = false
      })
    },
    loadSellContractInfo () {
      this.form.setFieldsValue({
        sell_contract_id: undefined
      })
      this.sellContractList = []
      this.sellContractFetching = true
      sell_contract_list({ project_id: this.project_id, is_expired: false, page: 1, page_size: 999, type: this.model['type'] === 1 ? 1 : 2 }).then((res) => {
        const result = res.data.entries || []
        this.sellContractList = result.reduce((acc, current) => {
          if (!acc.some(item => item.number === current.number)) {
            acc.push(current)
          }
          return acc
        }, [])
      }).finally(() => {
        this.sellContractFetching = false
      })
    },
    handleWarehouseChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleWarehouseSearch(value)
      }
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleAddAttachment () {
      this.visibleFrom = true
    },
    onAttachmentDelete (key) {
      const dataSource = [...this.otherData.attachment]
      this.otherData.attachment = dataSource.filter(item => item.key !== key)
    },
    handleAddCancel () {
      this.visibleFrom = false
      const form = this.$refs.attachmentCreateForm.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk (date) {
      const form = this.$refs.attachmentCreateForm.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, date)
          // 新增
          values.url = values.url.fileList[0].url
          const current_date = new Date()
          values.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
          this.otherData.attachment.push(values)
          this.visibleFrom = false
          form.resetFields()
        }
      })
    },
    ok () {
      if (this.otherData.attachment) {
        this.otherData.attachment = this.otherData.attachment.map(item => {
          item.key = undefined
          return item
        })
      }
      this.$emit('ok', this.otherData)
    },
    inventoryTotal () {
      const param = { project_id: this.project_id, trade_type: this.model['type'] }
      console.log('inventoryTotal', param)
      inventory_total(param).then(res => {
        if (res.code === 1000) {
          if (this.model['type'] === 1) {
            this.total_count = res.data
          } else if (this.model['type'] === 2) {
            this.remaining_total_count = res.data
          }
        }
      })
    }
  }
}
</script>
